import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="Footer">
      <div className="Footer-content">
        <p>&copy; 2024 Samitha Michael. All rights reserved.</p>
        <div className="Footer-socials">
          <a href="https://github.com/samithamichael98" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-github"></i>
            <span className="sr-only">GitHub</span>
          </a>
          <a href="https://www.linkedin.com/in/samithamichael/" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-linkedin"></i>
            <span className="sr-only">LinkedIn</span>
          </a>
          <a href="https://x.com/samithamichael" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-twitter"></i>
            <span className="sr-only">Twitter</span>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;